import React from 'react';
import { RCButton, RCToast } from '@reverbdotcom/cadence/components';
import { Modal } from '@reverbdotcom/commons';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';
import ProductReviewFlagForm from './ProductReviewFlagForm';

interface Props {
  productReviewId: string;
  cspId: string;
  reported: boolean;
}

export default function ProductReviewFlagButton({ productReviewId, cspId, reported }: Props) {
  const buttonState = useButtonState(reported);
  const [showSuccess, setShowSuccess] = React.useState(false);

  function onFlagCreated() {
    buttonState.closeModal();
    setShowSuccess(true);
  }

  return (
    <>
      <RCButton
        size="mini"
        variant="transparent"
        theme="danger"
        disabled={buttonState.disabled}
        onClick={buttonState.onClick}
      >
        {buttonState.text}
      </RCButton>

      <Modal
        data-product-review-flag-modal
        isOpen={buttonState.isModalOpen}
        onRequestClose={buttonState.closeModal}
        headerTitle={translate('modalTitle')}
      >
        <ProductReviewFlagForm
          cspId={cspId}
          productReviewId={productReviewId}
          onCancel={buttonState.closeModal}
          onFlagCreated={onFlagCreated}
        />
      </Modal>

      <RCToast isOpen={showSuccess} onClose={() => setShowSuccess(false)} text={translate('submitted')} />
    </>
  );
}

function useButtonState(reported: boolean) {
  const [isModalOpen, showModal] = React.useState(false);

  function buttonText() {
    if (reported) {
      return translate('reported');
    }

    return translate('report');
  }

  function closeModal() {
    showModal(false);
  }

  function onClick() {
    showModal(true);
  }

  return {
    text: buttonText(),
    disabled: reported,
    isModalOpen,
    closeModal,
    onClick,
  };
}

const translate = withPrefix('discovery.productReviews.flagReview');
